// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';
import { connect } from 'react-redux';

import Scrollable from '../shared/Scrollable';
import StyledForm from '../shared/StyledForm';
import Button from '../shared/Button';
import TextInput from '../shared/forms/TextInput';

const validate = values => {
    const errors = {};

    if (!values.title) {
        errors.title = 'Title is required';
    } else if (values.title.length <= 2) {
        errors.title = 'Title length must be at least 2 characters long';
    }

    if (!values.forenames) {
        errors.forenames = 'Forenames is a required field';
    } else if (values.forenames.length <= 2) {
        errors.forenames =
            'Forenames length must be at least 2 characters long';
    }

    if (!values.surname) {
        errors.surname = 'Surname is required';
    } else if (values.surname.length <= 2) {
        errors.surname = 'Surname length must be at least 2 characters long';
    }

    if (!values.telephone) {
        errors.telephone = 'Telephone is required';
    } else if (values.telephone.length <= 9) {
        errors.telephone =
            'Telephone length must be at least 9 characters long';
    }

    if (!values.email) {
        errors.email = 'Email is required';
    } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
        errors.email = 'Invalid email address';
    }

    return errors;
};

let ContactEditForm = props => {
    const { handleSubmit, submitting, dirty, error } = props;

    return (
        <StyledForm onSubmit={handleSubmit}>
            <Prompt
                when={dirty}
                message="You have made changes that will be lost if you proceed. Are you sure you want to continue?"
            />

            <Scrollable additionalClassName="scroll-area">
                <div className="flex">
                    <div className="col">
                        <Field
                            name="forenames"
                            label="Forenames"
                            component={TextInput}
                            error={error}
                        />
                        <Field
                            name="surname"
                            label="Surname"
                            component={TextInput}
                            error={error}
                        />
                    </div>
                    <div className="col">
                        <Field
                            name="telephone"
                            label="Telephone"
                            component={TextInput}
                            error={error}
                        />
                        <Field
                            name="email"
                            label="Email"
                            component={TextInput}
                            error={error}
                        />
                    </div>
                </div>
            </Scrollable>

            <div className="sticky-footer">
                <Button type="submit" disabled={submitting}>
                    Save & Continue
                </Button>
            </div>
        </StyledForm>
    );
};

ContactEditForm = reduxForm({
    form: 'contactEditForm',
    validate,
})(ContactEditForm);

const mapStateToProps = state => {
    const edit = state.contacts.edit;

    return {
        contact: edit.contact,
    };
};

export default connect(mapStateToProps)(ContactEditForm);



// WEBPACK FOOTER //
// ./src/components/Contacts/Edit.js